import { Edit } from '@mui/icons-material';
import {
  Button,
  CircularProgress,
  IconButton,
  Typography,
} from '@mui/material';
import { Column, Row } from 'components/Layout';
import { CurrencyCode } from 'further-types/lp/vehicle';
import FormField from 'further-ui/components/FormField';
import NumberInput from 'further-ui/components/NumberInput';
import { numberToCurrencyString } from 'further-ui/utils';
import { useState } from 'react';

type Props = {
  targetValue: number;
  onSave: (value: number) => void;
  currentValue: number;
  isUpdatingOnboardingSettings: boolean;
  baseCurrency: CurrencyCode;
};

const TargetValue: React.FC<Props> = ({
  targetValue,
  onSave,
  currentValue,
  isUpdatingOnboardingSettings,
  baseCurrency,
}) => {
  const [value, setValue] = useState(targetValue);
  const [isInEditMode, setIsInEditMode] = useState(false);

  const percentage = value ? Math.round((currentValue / value) * 100) : 0;

  const handleChangeTargetValue = (value: number | null) => {
    setValue(value ?? 0);
  };

  const handleSaveTargetValue = () => {
    onSave(value);
    setIsInEditMode(false);
  };

  return (
    <Row centered fullWidth justify="space-between" spacing="sm">
      <Column spacing="xs" fullWidth>
        <Typography variant="h6" color="grey.600">
          Target
        </Typography>
        {isInEditMode ? (
          <Row spacing="sm" centered>
            <FormField size="md">
              <NumberInput
                fullWidth
                placeholder="Enter target"
                value={value}
                decimals={2}
                onChange={handleChangeTargetValue}
                currency={baseCurrency}
                size="large"
              />
            </FormField>
            <Button
              variant="contained"
              color="primary"
              size="large"
              onClick={handleSaveTargetValue}
              disabled={isUpdatingOnboardingSettings}
            >
              Save
            </Button>
          </Row>
        ) : (
          <Row centered spacing="xs">
            <Typography variant="h2">
              {numberToCurrencyString(targetValue, {
                currency: baseCurrency,
              })}
            </Typography>
            <IconButton
              onClick={() => {
                setIsInEditMode(true);
              }}
              disabled={isUpdatingOnboardingSettings}
              size="small"
            >
              <Edit fontSize="small" />
            </IconButton>
          </Row>
        )}
      </Column>
      <Row centered spacing="xs">
        <Typography variant="h6">{percentage}%</Typography>
        <CircularProgress
          variant="determinate"
          size={24}
          value={percentage}
          enableTrackSlot
        />
      </Row>
    </Row>
  );
};

export default TargetValue;
